import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function RenderText(formattedValue, {className}) {
	return <StyledRenderText className={className}>{formattedValue}</StyledRenderText>;
}

RenderText.proptTypes = {
	formattedValue: PropTypes.string.isRequired,
	className: PropTypes.string
};

RenderText.defaultProps = {
	className: 'render-text'
};

export default RenderText;

const StyledRenderText = styled.div``;
